import axios from './axios';

export default class LoanService {
  static createLoan(offer_public_id) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/loan/create', { offer_public_id });
  }

  static getLoanData(agreement_id) {
    return axios.get(window.entityCabinetSettings.openApi.url + `/api/agreement/loan/${agreement_id}`);
  }

  static downloadLoan(agreement_id) {
    return axios.get(window.entityCabinetSettings.openApi.url + `/api/agreement/loan/download/${agreement_id}`, {
      responseType: 'blob'
    });
  }
 
  static signAgreement(offer_public_id, agreement_id, otp) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/agreement/loan/sign', { offer_public_id, agreement_id, otp });
  }

  static getOtpCode() {
    return axios.get(window.entityCabinetSettings.openApi.url + '/api/notification/sms/otp');
  }

  static getLoanOtpCode(loan_amount) {
    return axios.get(window.entityCabinetSettings.openApi.url + '/api/notification/sms/otp', {
      params: {
        purpose: 'loan',
        loan_amount
      }
    });
  }

  static getLoansList(params) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/loan/list', params);
  }

  static getLoansArchivedList(params) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/loan/archived/list', params);
  }

  static getLoanById(id) {
    return axios.get(window.entityCabinetSettings.openApi.url + `/api/loan/${id}`);
  }

  static loanPayment(payload) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/loan/pay', payload);
  }

  static getEarlyRepaymentPreview(loan_public_id) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/loan/early-repayment/preview', { loan_public_id }, {
      responseType: 'blob',
    });
  }

  static sendEarlyRepaymentOtp(loan_public_id) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/loan/early-repayment/notify/send-otp', { loan_public_id });
  }

  static notifyEarlyRepayment(payload) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/loan/early-repayment/notify', payload);
  }

  static getEarlyRepaymentStatus(loan_public_id) {
    return axios.get(window.entityCabinetSettings.openApi.url + `/api/loan/early-repayment/status/${loan_public_id}`);
  }

  static calculateEarlyRepayment(loan_public_id) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/loan/early-repayment/calculate', { loan_public_id });
  }

  static payEarlyRepayment(payload) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/loan/early-repayment/pay', payload);
  }

  static downloadEarlyRepaymentNotification(document_id) {
    return axios.get(window.entityCabinetSettings.openApi.url + `/api/loan/early-repayment/download/${document_id}`, {
      responseType: 'blob'
    });
  }
}